import { render, staticRenderFns } from "./PollingOptionSettings.vue?vue&type=template&id=7c8ae635&"
import script from "./PollingOptionSettings.vue?vue&type=script&lang=js&"
export * from "./PollingOptionSettings.vue?vue&type=script&lang=js&"
import style0 from "./PollingOptionSettings.vue?vue&type=style&index=0&id=7c8ae635&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QItem,QItemSection,QItemLabel,QToggle});
